import { grey } from "@mui/material/colors";
import { HOME_BODY_COLOR } from "styles/oneOffColor";

const styles = {
  card: {
    p: 1,
    border: `1px solid ${grey[200]}`,
    borderRadius: 4,
  },
  planTitleCard: {
    pt: 1.5,
    pb: 3,
    px: 3,
    borderRadius: 4,
    mb: 3,
  },
  iconBlock: {
    fontSize: 20,
    backgroundColor: HOME_BODY_COLOR,
    borderRadius: 2,
    width: 35,
    height: 35,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    p: 1,
    mr: 3,
  },
  strike: {
    textDecoration: "line-through",
    color: "#7a9f9c",
    fontSize: 22,
  },
  price: {
    display: "flex",
    gap: 1,
    color: "white",
    fontSize: 25,
    alignItems: "center",
  },
  link: {
    fontSize: 13,
    color: "white",
    textDecoration: "underline",
    textDecorationColor: "#7a9f9c",
  },
  chipVa: {
    backgroundColor: "white",
    px: 1,
  },
  discount: {},
  rolloverBox: {
    backgroundColor: "rgba(255,255,255,0.12)",
    borderRadius: 2,
    p: 1.5,
    mt: 1.5,
    mb: 1,
  },
  rolloverRow: { display: "flex", justifyContent: "space-between" },
  rolloverLabel: { color: "rgba(255,255,255,0.7)", fontSize: 11 },
  rolloverLabelDim: { color: "rgba(255,255,255,0.8)", fontSize: 11 },
  rolloverValue: { color: "white", fontSize: 11, fontWeight: 700 },
  rolloverValueAccent: { color: "yellow.main", fontSize: 11 },
  rolloverTotal: { color: "white", fontSize: 11, fontWeight: 600 },
  rolloverDivider: { borderColor: "rgba(255,255,255,0.2)", my: 0.75 },
  rolloverProgress: {
    mb: 1,
    borderRadius: 1,
    height: 5,
    backgroundColor: "rgba(255,255,255,0.2)",
    "& .MuiLinearProgress-bar": { backgroundColor: "yellow.main" },
  },
};

export default styles;
